module.exports = require('./helpers/bundle-url').getBundleURL('9rAa3') + "trello-left.4f52d13c.svg";